import React from 'react';
import MinAndMaxLength from './common/MinAndMaxLength';
import PercentageColumnOptions from "./common/PercentageColumnOptions"
function PercentageColumnConfig(props) {
    return (
        <React.Fragment>
            <MinAndMaxLength {...props} />
            <PercentageColumnOptions {...props} />
        </React.Fragment>
    );
}

export default PercentageColumnConfig;